import * as $ from 'jquery';
import { isValid } from 'date-fns';
import { convertToUTC } from '@mode/shared/util-js';

export function ModeDatePickerDirective($timeout) {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      modeDatePicker: '@',
      class: '@',
      id: '@',
      name: '@',
      placeholder: '@',
      showIcon: '<?',
      adjustForTimezone: '<?',
      onChange: '&?',
      onKeyup: '&?',
      disabled: '@?',
    },

    template: `
      <div><input type="text"
             class="{{ class }}"
             id="{{ id }}"
             name="{{ name }}"
             placeholder="{{ placeholder }}"
             ng-class="{'datepicker-open': datepicker.open, 'mode-datepicker': showIcon}"
             ng-model="date"
             ng-focus="open()"
             ng-click="open()"
             ng-change="handleChange(date)"
             ng-keyup="handleKeyup(date)"
             is-open="datepicker.open"
             uib-datepicker-popup="yyyy-MM-dd"
             datepicker-options="datepicker.options"
             datepicker-append-to-body="true"
             popup-placement="auto bottom-right"
             show-button-bar="false"
             on-open-focus="false"
             autocomplete="off"></div>`,

    link: {
      pre: function (scope: any, elm, attrs: any, ngModel) {
        scope.datepicker = {
          open: false,
          options: {
            showWeeks: false,
          },
        };

        // use placeholder as initDate if valid
        const placeholder = convertToUTC(new Date(scope.placeholder));
        if (isValid(placeholder)) {
          scope.datepicker.options.initDate = placeholder;
        }
      },
      post: function (scope: any, elm, attrs: any, ngModel) {
        elm[0].className = '';
        elm[0].removeAttribute('name');
        elm[0].removeAttribute('id');
        elm[0].removeAttribute('type');
        elm[0].removeAttribute('placeholder');

        if (scope.disabled) {
          elm.find('input').attr('disabled', 'true');
        }

        // Placeholder is watched separately due to async filter option loading
        scope.$watch('placeholder', function (date: string) {
          const placeholder = convertToUTC(new Date(date));
          if (isValid(placeholder)) {
            scope.datepicker.options.initDate = placeholder;
          }
        });

        scope.$watch('modeDatePicker', function (date: string) {
          let parseDate: Date | null = null;

          if (!scope.modeDatePicker && !scope.date) {
            scope.date = null;
            return;
          }

          if (scope.modeDatePicker) parseDate = convertToUTC(new Date(scope.modeDatePicker));
          if (date) parseDate = convertToUTC(new Date(date));

          if (!isValid(parseDate)) {
            // invalid date so use today
            parseDate = convertToUTC(new Date());
          }

          scope.date = parseDate;
          scope.datepicker.options.initDate = parseDate;
        });

        scope.open = function () {
          $(window).trigger('mode.datepicker.datepickerOpen', [scope.id]);
          scope.datepicker.open = true;
        };

        function handleDocumentOpenEvent(event, id) {
          if (id !== scope.id && scope.datepicker.open) {
            $timeout(() => {
              scope.datepicker.open = false;
            });
          }
        }

        function adjustForLocalTimezone(date: Date): Date {
          if (!date) {
            return date;
          }
          const adjustedDate = new Date(date);
          adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset());
          return adjustedDate;
        }

        $(window).on('mode.datepicker.datepickerOpen', handleDocumentOpenEvent);

        scope.$on('$destroy', function () {
          $(window).off('mode.datepicker.datepickerOpen', handleDocumentOpenEvent);
        });

        scope.handleChange = function ($value: Date) {
          if (scope.onChange) {
            const date = scope.adjustForTimezone ? adjustForLocalTimezone($value) : $value;
            scope.onChange({ $value: date });
          }
        };

        scope.handleKeyup = function ($value: Date) {
          if (scope.onKeyup) {
            const date = scope.adjustForTimezone ? adjustForLocalTimezone($value) : $value;
            scope.onKeyup({ $value: date });
          }
        };
      },
    },
  };
}

ModeDatePickerDirective.$inject = ['$timeout'];
